import store from '@store/index'
import { userUsesNewUiEligible } from '@utils/userUsesNewUiEligible'
import { enterTeamUserBusiness } from '@utils/postLoginRedirect'
import { agencyBillingRecoveryRedirect } from '@utils/agencyBillingRecoveryRedirect'
import {
  hasRepuAgencyAccess,
  isAgencySubscribed,
  isRepuagencyProductHost,
} from '@utils/subscription'

function businessNeedsGoogleConnect(user) {
  if (!user?.business) return false;
  const instaOnly = user.business.is_insta_stream && !user.business.is_social_fusion && !user.business.is_tap_engine && !user.business.is_social_review && !user.business.is_text_requester && !user.business.is_reply_engine;
  const zensocialOnly = user.business.is_zensocial;
  if (instaOnly || zensocialOnly) return false;
  const noLocation = user.location == null;
  const noGoogleAccounts = !user.google_accounts || !user.google_accounts.length;
  return noLocation || noGoogleAccounts;
}

function businessUsesNewUi(user) {
  return userUsesNewUiEligible(user)
}

function agencyOnTrial(user) {
  return !!(user?.on_trial || user?.agency?.owner?.on_trial)
}

function AuthGuard(to, from, next) {
  let user = store.getters['auth/user'];
  let config = store.getters['app/config'];
  const isReputationHub = origin.includes('reputationhub.io');
  const isRepuAgency = origin.includes('localhost') ||
      origin.includes('repuagency.com') ||
      origin.includes('reputationhub.io') ||
      (config?.custom_domain && origin.includes(config.custom_domain));
  if (user) {
    if (user.role === 'Admin') {
      next({ name: 'admin.agencies.index' })
    } else if (user.role === 'Team') {
      enterTeamUserBusiness(store, (location) => next(location), user).then((result) => {
        if (result === false) {
          next({ name: 'team.dashboard' })
        }
      })
    }  else if (user.role === 'Agency') {
      if (
        isRepuagencyProductHost() &&
        !agencyOnTrial(user) &&
        (agencyBillingRecoveryRedirect(user) ||
          (!hasRepuAgencyAccess(user) && !isAgencySubscribed(user)))
      ) {
        next({ name: 'agency.subscription' })
      } else if(isRepuAgency || isReputationHub){
        next({ name: 'agency.customers.index' })
      }else{
        next({ name: 'agency.dashboard' })
      }
    } else if (user.role === 'Business') {
      const nu = businessUsesNewUi(user);
      if (businessNeedsGoogleConnect(user)) {
        next({ name: nu ? 'new-business.settings' : 'business.settings' });
      } else if (isRepuAgency || isReputationHub) {
        next({ name: nu ? 'new-business.dashboard' : 'business.dashboard' });
      } else if (user.business.is_social_fusion) {
        next({ name: nu ? 'new-business.social-posts' : 'business.social-posts' });
      } else if (user.business.is_insta_stream) {
        next({ name: nu ? 'new-business.instagram-widget' : 'business.instagram-widget' });
      } else {
        next({ name: nu ? 'new-business.dashboard' : 'business.dashboard' });
      }
    } else {
      next()
    }
  } else {
    next()
  }
}

export default AuthGuard
